import styled from 'styled-components';
import { Typography } from '@mui/material';
import { color } from '../../theme/Color';

export const NumberContainer = styled(Typography)`
  font-size: 16px !important;
  font-family: 'Inter !important';
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 22px;
  color: ${color._000000} !important;

  @media (max-width: 600px) {
    font-size: 16px !important;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    font-size: 16px !important;
  }

  & span {
    font-family: 'Inter';
    font-weight: 700;
    color: ${({ mode }) =>
      mode === 'light'
        ? `${color._000000} !important`
        : `${color._ffffff} !important`};
  }

  &.css-ag7rrr-MuiTypography-root {
    font-weight: 700;
    font-family: 'Inter';
  }

  & .abbreviation {
    font-size: 16px !important;
    color: ${({ mode }) =>
      mode === 'light'
        ? `${color._000000} !important`
        : `${color._ffffff} !important`};
  }
`;

export const DescriptionContainer = styled(Typography)`
  font-size: 14px !important;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  color: ${({ mode }) => (mode === 'light' ? color._616161 : color._C0C0C0)};
  text-transform: capitalize;
`;

export const SubTextContainer = styled(Typography)`
  display: block;
  font-size: 14px !important;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  color: ${({ mode }) => (mode === 'light' ? color._616161 : color._C0C0C0)};
  text-transform: capitalize;
`;
